import React from 'react';
import { Typography } from '../../../../base';
import { UnifiedAnswerType } from '../AnswerActionComponents.interfaces';

interface BooleanActionProps {
    onSelectionChange: (value: UnifiedAnswerType) => void;
}

const BooleanAction: React.FC<BooleanActionProps> = ({ onSelectionChange }) => {
    // TODO: Implement boolean logic (e.g., Switch, Yes/No buttons)
    React.useEffect(() => {
        onSelectionChange(undefined); // Initialize as no selection
    }, [onSelectionChange]);
    return <Typography>Answer Type: Boolean (Not Implemented)</Typography>;
};

export default BooleanAction;
